export default "__VITE_ASSET__LQ_dg6Rw__"